export default "__VITE_ASSET__Cwqw3QdW__";